import React, { memo, useState, useCallback } from 'react';
import { Modal } from 'antd';

import { OTP_INPUT_AMOUNT } from '../../../utils/Constants';
import { showNotificationDialog } from '../../../utils';
import OtpInput from '../../../components/OtpInput/OtpInput';
import styles from './styles.module.css';
import { t } from 'i18next';
import CustomAntButton from '../../../components/CustomAntButton/CustomAntButton';

type SpotIdentificationCodeModalProps = {
    isOpen: boolean;
    onSubmit: (otpValue: string) => Promise<void>;
    onCancel: () => void;
};

const SpotIdentificationCodeModal = memo(({ isOpen, onSubmit, onCancel }: SpotIdentificationCodeModalProps) => {
    const [otpValue, setOtpValue] = useState('');

    /**
     * onSubmitを実行してモーダルを閉じる
     */
    const onSubmitModal = () => {
        try {
            if (otpValue.split(' ').join('').length < OTP_INPUT_AMOUNT) {
                showNotificationDialog(
                    'error',
                    'input_value_code_fail',
                    t('notification.title'),
                    t('error-message.spot-code.enter-code'),
                );
                return;
            }
            if (typeof onSubmit !== 'function') throw new Error('onSubmit is not function');
            void onSubmit(otpValue.trim());
        } catch {}
    };

    /**
     * モーダルを閉じる
     */
    const onCloseModal = () => {
        try {
            if (typeof onCancel !== 'function') throw new Error('onCancel is not function');
            void onCancel();
        } catch {}
    };

    /**
     * inputの値が変更するの処理
     */
    const handleInputChange = useCallback((value: string) => {
        setOtpValue(value);
    }, []);

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            closable={false}
            title={t('modal.spot-code')}
            width={300}
            open={isOpen}
            centered
            onCancel={() => onCloseModal()}
            className={styles.spotIdentificationCodeModal}
            style={{ textAlign: 'center' }}
            footer={null}
        >
            <div className={styles.spotIdentificationCodeWrapper}>
                <p className={styles.spotIdentificationTextContent}>{t('modal.enter-spot-code')}</p>
                <OtpInput value={otpValue} inputAmount={OTP_INPUT_AMOUNT} onChange={handleInputChange} />
            </div>
            <CustomAntButton className={styles.spotIdentificationBtnSubmit} onClick={onSubmitModal}>
                {t('button.confirm')}
            </CustomAntButton>
            <CustomAntButton type="outlined" className={styles.spotIdentificationBtnCancel} onClick={onCloseModal}>
                {t('button.close')}
            </CustomAntButton>
        </Modal>
    );
});

export default SpotIdentificationCodeModal;
